import { CircularProgress } from '@mui/material';
import styles from "./UAEPassAuthLoader.module.css"

const UAEPassAuthLoader = () => {
    return (
        <div className={`${styles.authLoader}`}>
            <div className={`${styles.authLoaderContentWrap}`}>
                <p>Please wait while we are fetching information from UAE Pass</p>
                <CircularProgress className={styles.loader} />
            </div>
        </div>
    )
};

export default UAEPassAuthLoader;